/**
 * @component LocationSection
 * @description 본사/지사 탭 선택 + 주소·전화·교통편 정보 + 네이버 지도를 loc-grid 구조로 제공하는 위치 안내 컴포넌트입니다.
 * @usage CompanyAboutPage의 '오시는 길' 섹션에서 사용됩니다.
 */

import { useState } from 'react';
import { MapPin } from 'lucide-react';
import { officeLocations } from '../../constants/companyData';
import NaverMap from './NaverMap';

export default function LocationSection() {
  const [activeId, setActiveId] = useState(officeLocations[0].id);

  const active = officeLocations.find((l) => l.id === activeId);

  const handleTabClick = (id) => {
    setActiveId(id);
  };

  return (
    <div className="loc-grid">
      {/* 정보 패널 */}
      <div className="loc-side">
        {/* 지점 탭 */}
        <div className="loc-tabs" role="tablist">
          {officeLocations.map((loc) => (
            <button
              key={loc.id}
              className={`loc-tab ${activeId === loc.id ? 'is-active' : ''}`}
              onClick={() => handleTabClick(loc.id)}
              role="tab"
              aria-selected={activeId === loc.id}
            >
              {loc.name}
            </button>
          ))}
        </div>

        {/* 지점명 */}
        <div className="loc-name">
          {active.name}
        </div>

        {/* 주소 */}
        <div className="loc-address">
          <MapPin size={16} aria-hidden="true" />
          <div>
            <strong>{active.address}</strong>
            <span>{active.addressDetail}</span>
          </div>
        </div>
      </div>

      {/* 네이버 지도 */}
      <div className="loc-map">
        <NaverMap
          branches={officeLocations}
          selectedBranchId={activeId}
        />
      </div>
    </div>
  );
}
